<template>
  <div class="xs-12" :class="{ 'waiting-payment': waitingForPayment }">
    <div v-if="registration.waiting_payment || registration.state === 'on_hold'" class="xs-12 waiting-payment__heading">
      <h2 class="dea-heading--medium__ml dea-text--negative ">In attesa di pagamento</h2>
      <h2 v-if="registration.state === 'on_hold'" class="dea-heading--medium__m dea-text--negative ">
        Hai scelto di effettuare il pagamento tramite
        <b>Bonifico</b>: il tuo ordine è in attesa di conferma.
      </h2>
      <div class="dea-heading--regular__xm dea-text--negative "></div>
    </div>
    <div
      v-else-if="registration.state === 'new' || registration.state === 'completed'"
      class="xs-12 waiting-payment__heading"
    >
      <h2 class="dea-heading--medium__ml dea-text--negative ">In attesa di completamento</h2>
      <div class="dea-heading--regular__xm dea-text--negative "></div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "TicketToPayWrapper",
  props: {
    registration: {
      type: Object,
      default: () => ({}),
    },
    waitingForPayment: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.waiting-payment {
  background-color: $dea-color-target-magenta-formazione;
  margin-bottom: $space-large;
  padding-bottom: $space-base;

  &__heading {
    margin-bottom: $space-base;
    padding-top: $space-x-small;

    h2 {
      margin-bottom: $space-x-small;
      margin-top: 0;
    }
  }

  .ticket-container {
    margin-bottom: $space-xxx-small;
  }
}
</style>
